<template>
  <div>
    <div class="page-hero">
      <div class="container">
        <span class="section__label">Тарифы</span>
        <h1 class="page-hero__title">Прозрачные цены без скрытых платежей</h1>
        <p class="page-hero__text">Тарифы — ориентир. Для первых пилотных компаний действуют специальные условия: 3 месяца за 20% от прайса, внедрение бесплатно — цена фиксируется в пилотном договоре.</p>
      </div>
    </div>

    <section class="section">
      <div class="container">
        <div class="trial-banner">
          <div class="trial-banner__icon" aria-hidden="true">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div class="trial-banner__body">
            <div class="trial-banner__title">Демо-доступ 14 дней — бесплатно, без карты</div>
            <div class="trial-banner__text">Настроим систему под ваши формулы за вас, посчитаем реальный период и сверим итог с вашим Excel. Берём 5 компаний в пилотную программу — внедрение бесплатно.</div>
          </div>
          <base-button to="/demo" size="md" class="trial-banner__cta">Получить демо-доступ</base-button>
        </div>

        <div class="billing-toggle" role="group" aria-label="Период оплаты">
          <button
            type="button"
            class="billing-toggle__btn"
            :class="{ 'billing-toggle__btn--active': billing === 'month' }"
            @click="billing = 'month'"
          >В месяц</button>
          <button
            type="button"
            class="billing-toggle__btn"
            :class="{ 'billing-toggle__btn--active': billing === 'year' }"
            @click="billing = 'year'"
          >За год <span class="billing-toggle__hint">−17%</span></button>
        </div>

        <div class="pricing-grid">
          <div v-for="plan in plans" :key="plan.name" class="plan" :class="{ 'plan--featured': plan.featured }">
            <div v-if="plan.featured" class="plan__badge">Популярный</div>
            <h3 class="plan__name">{{ plan.name }}</h3>
            <div class="plan__price">
              <span class="plan__amount">{{ billing === 'year' ? plan.priceYear : plan.priceMonth }}</span>
              <span class="plan__period">{{ billing === 'year' ? '/ год' : '/ мес' }}</span>
            </div>
            <div class="plan__price-note" v-if="billing === 'year'">2 месяца в подарок</div>
            <p class="plan__desc">{{ plan.desc }}</p>
            <ul class="plan__features">
              <li v-for="f in plan.features" :key="f">{{ f }}</li>
            </ul>
            <base-button
              :to="plan.featured ? '/demo' : '/contacts'"
              :variant="plan.featured ? 'primary' : 'outline'"
              size="md"
              style="width:100%; justify-content:center;"
            >{{ plan.cta }}</base-button>
          </div>
        </div>

        <div class="onprem">
          <div class="onprem__header">
            <h2 class="onprem__title">On-premise: установка на ваших серверах</h2>
            <p class="onprem__subtitle">Доступно с тарифа «Корпоратив» (от ~200 сотрудников). Данные о зарплатах не покидают вашу сеть — Docker-стек разворачивается на инфраструктуре заказчика.</p>
          </div>
          <div class="onprem-grid">
            <div v-for="plan in onPremPlans" :key="plan.name" class="onprem-card" :class="{ 'onprem-card--featured': plan.featured }">
              <div v-if="plan.featured" class="plan__badge">Рекомендуем</div>
              <h3 class="onprem-card__name">{{ plan.name }}</h3>
              <div class="onprem-card__price">{{ plan.price }}</div>
              <div class="onprem-card__note">{{ plan.note }}</div>
              <ul class="onprem-card__features">
                <li v-for="f in plan.features" :key="f">{{ f }}</li>
              </ul>
              <base-button to="/contacts" variant="outline" size="md" style="width:100%; justify-content:center;">Связаться</base-button>
            </div>
          </div>
        </div>

        <div class="faq">
          <h2 class="faq__title">Частые вопросы</h2>
          <div class="faq__list">
            <div v-for="item in faq" :key="item.q" class="faq__item">
              <div class="faq__q" @click="item.open = !item.open">
                {{ item.q }}
                <span class="faq__arrow">{{ item.open ? '↑' : '↓' }}</span>
              </div>
              <div v-if="item.open" class="faq__a">{{ item.a }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import BaseButton from '../components/ui/BaseButton.vue'
export default {
  name: 'PricingPage',
  components: { BaseButton },
  data() {
    return {
      billing: 'month',
      plans: [
        {
          name: 'Старт',
          priceMonth: 'от ₽ 19 900',
          priceYear: 'от ₽ 199 000',
          desc: 'Для небольших команд до 50 сотрудников',
          features: ['15 рабочих мест (аккаунтов) в системе', 'Конструктор формул', 'Импорт данных из Excel', 'Онлайн-оценка премии сотруднику', 'Ведомость Excel/CSV', 'Email-поддержка'],
          cta: 'Начать',
          featured: false,
        },
        {
          name: 'Бизнес',
          priceMonth: 'от ₽ 39 900',
          priceYear: 'от ₽ 399 000',
          desc: 'Для компаний от 51 до 200 сотрудников. Демо-доступ 14 дней.',
          features: ['50 рабочих мест (аккаунтов) в системе', 'Все возможности «Старт»', 'KPI-карты и показатели эффективности', 'Положение о премировании из ваших формул', 'Помощь в настройке формул', 'Приоритетная поддержка'],
          cta: 'Получить демо-доступ',
          featured: true,
        },
        {
          name: 'Корпоратив',
          priceMonth: 'от ₽ 79 900',
          priceYear: 'от ₽ 799 000',
          desc: 'Для крупных компаний от 201 до 500 сотрудников',
          features: ['120 рабочих мест (аккаунтов) в системе', 'Все возможности «Бизнес»', 'Делегирование ролей и доступа по подразделениям', 'Настройка под процессы', 'Выделенный менеджер', 'Обучение сотрудников'],
          cta: 'Связаться',
          featured: false,
        },
        {
          name: 'Энтерпрайз',
          priceMonth: 'от ₽ 120 000',
          priceYear: 'от ₽ 1,2 млн',
          desc: 'Для холдингов и сетей от 500 сотрудников',
          features: ['Рабочие места без ограничений', 'Все возможности «Корпоратив»', 'SLA и интеграции', 'Выделенная инстанция', 'On-premise: установка на ваших серверах — от 1,6 млн ₽/год', 'Доработки под процессы компании'],
          cta: 'Связаться',
          featured: false,
        },
      ],
      onPremPlans: [
        {
          name: 'Вариант A — годовая лицензия',
          price: 'от ₽ 1 600 000 / год',
          note: '+ установка 250 000 ₽ единоразово. Продление — 100% цены (индексация ≤ ИПЦ).',
          features: ['Корпоратив (до 500 сотрудников) — 1,6 млн ₽/год', 'Энтерпрайз (500+) — от 2,4 млн ₽/год', 'Обновления и приоритетная поддержка включены', 'Docker-стек на серверах заказчика'],
          featured: true,
        },
        {
          name: 'Вариант B — бессрочная лицензия',
          price: '₽ 4 000 000',
          note: '+ установка 250 000 ₽ единоразово. По запросу.',
          features: ['Корпоратив, до 500 сотрудников', '1-й год поддержки включён', 'Далее поддержка и обновления — 25% в год от стоимости лицензии', 'Для CAPEX-политики и требований КИИ'],
          featured: false,
        },
      ],
      faq: [
        { q: 'Есть ли пробный период?', a: 'Да — демо-доступ на 14 дней. Настройку системы под ваши формулы берём на себя, сверим итог расчёта с вашим Excel.', open: false },
        { q: 'Что такое «рабочее место»?', a: 'Аккаунт с доступом в систему: HR-менеджер, руководитель, сотрудник в личном кабинете. Рассчитывать премии можно на всю численность компании — в лимит входят только те, кто заходит в систему. Если мест перестанет хватать, ничего не заблокируется: мы просто предложим перейти на следующий тариф.', open: false },
        { q: 'Можно ли сменить тариф?', a: 'Да, в любой момент можно повысить или понизить тариф. Изменение вступает в силу с нового расчётного периода.', open: false },
        { q: 'Как происходит оплата?', a: 'По выставленному счёту — ежемесячно или сразу за год. При оплате за год действует скидка 17%: вы платите за 10 месяцев, 2 месяца в подарок.', open: false },
        { q: 'Входит ли внедрение в стоимость?', a: 'Для пилотных компаний внедрение бесплатно. Дальше базовое внедрение и обучение включены в тариф.', open: false },
        { q: 'В каком тарифе есть KPI-карты и делегирование ролей?', a: 'KPI-карты и показатели эффективности доступны с тарифа «Бизнес». Делегирование ролей и доступа по подразделениям — в тарифе «Корпоратив». Онлайн-оценка премии сотруднику есть уже в «Старте».', open: false },
        { q: 'Можно ли установить систему на свои сервера?', a: 'Да. On-premise доступен с уровня «Корпоратив»: годовая лицензия от 1,6 млн ₽ в год с обновлениями и поддержкой, установка — 250 тыс. ₽ единоразово. Данные о зарплатах не покидают вашу сеть. Бессрочная лицензия — по запросу.', open: false },
        { q: 'Чем вы отличаетесь от 1С:ЗУП?', a: '1С:ЗУП — про начисление зарплаты, CandB.pro — про мотивацию: конструктор формул премий, KPI-карты и прозрачный ответ сотруднику «почему столько». Ведомость выгружается в Excel/CSV для загрузки в 1С, прямая интеграция с 1С:ЗУП — в разработке.', open: false },
        { q: 'Почему дороже простых KPI-сервисов?', a: 'Вы платите за полноту: двухконтурный расчёт (онлайн-оценка плюс авторитетный серверный прогон), автогенерация Положения о премировании из ваших формул, ролевая модель до подразделения и готовые документы для бухгалтерии — а не только табличка с KPI.', open: false },
      ],
    }
  },
}
</script>

<style scoped>
.page-hero {
  background: linear-gradient(135deg, #1E3A8A, #2563EB);
  color: white;
  padding: 140px 0 80px;
}
.page-hero__title { font-size: 2.5rem; font-weight: 800; margin: 12px 0 16px; }
.page-hero__text { font-size: 1.125rem; opacity: 0.85; max-width: 520px; }

.trial-banner {
  display: flex;
  align-items: center;
  gap: 20px;
  background: linear-gradient(135deg, #ECFDF5 0%, #F0FDF4 100%);
  border: 1px solid #A7F3D0;
  border-left: 4px solid var(--secondary, #10B981);
  border-radius: var(--radius);
  padding: 20px 24px;
  margin-bottom: 40px;
}
.trial-banner__icon {
  width: 48px; height: 48px;
  background: var(--secondary, #10B981);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.trial-banner__body { flex: 1; }
.trial-banner__title {
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--dark);
  margin-bottom: 4px;
}
.trial-banner__text {
  font-size: 0.9375rem;
  color: var(--gray);
  line-height: 1.55;
}
.trial-banner__cta { flex-shrink: 0; }

@media (max-width: 768px) {
  .trial-banner { flex-direction: column; align-items: flex-start; text-align: left; }
}

.billing-toggle {
  display: flex;
  justify-content: center;
  gap: 0;
  margin-bottom: 36px;
  border: 1px solid var(--border);
  border-radius: 100px;
  padding: 4px;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  background: white;
}
.billing-toggle__btn {
  border: none;
  background: transparent;
  font: inherit;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--gray);
  padding: 8px 20px;
  border-radius: 100px;
  cursor: pointer;
}
.billing-toggle__btn--active {
  background: var(--primary);
  color: white;
}
.billing-toggle__hint {
  font-size: 0.8125rem;
  opacity: 0.85;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  align-items: start;
  margin-bottom: 80px;
}
.plan {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 36px 32px;
  position: relative;
}
.plan--featured { border-color: var(--primary); box-shadow: var(--shadow-hover); transform: translateY(-8px); }
.plan__badge {
  position: absolute; top: -14px; left: 50%; transform: translateX(-50%);
  background: var(--primary); color: white; font-size: 0.8125rem; font-weight: 600;
  padding: 4px 16px; border-radius: 100px; white-space: nowrap;
}
.plan__name { font-size: 1.25rem; font-weight: 700; margin-bottom: 16px; }
.plan__amount { font-size: 1.875rem; font-weight: 800; color: var(--primary); }
.plan__period { font-size: 0.9375rem; color: var(--gray); margin-left: 4px; }
.plan__price-note { font-size: 0.8125rem; color: var(--secondary, #10B981); font-weight: 600; margin-top: 4px; }
.plan__desc { color: var(--gray); font-size: 0.875rem; margin: 12px 0 24px; min-height: 40px; }
.plan__features { list-style: none; margin-bottom: 28px; display: flex; flex-direction: column; gap: 10px; }
.plan__features li { font-size: 0.9375rem; padding-left: 22px; position: relative; }
.plan__features li::before { content: '✓'; position: absolute; left: 0; color: var(--secondary); font-weight: 700; }

.onprem { margin-bottom: 80px; }
.onprem__header { text-align: center; max-width: 640px; margin: 0 auto 32px; }
.onprem__title { font-size: 1.75rem; font-weight: 700; margin-bottom: 12px; }
.onprem__subtitle { color: var(--gray); font-size: 0.9375rem; line-height: 1.6; }
.onprem-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  max-width: 800px;
  margin: 0 auto;
}
.onprem-card {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 36px 32px;
  position: relative;
}
.onprem-card--featured { border-color: var(--primary); box-shadow: var(--shadow-hover); }
.onprem-card__name { font-size: 1.125rem; font-weight: 700; margin-bottom: 16px; }
.onprem-card__price { font-size: 1.5rem; font-weight: 800; color: var(--primary); }
.onprem-card__note { font-size: 0.8125rem; color: var(--gray); margin: 8px 0 20px; line-height: 1.5; }
.onprem-card__features { list-style: none; margin-bottom: 28px; display: flex; flex-direction: column; gap: 10px; }
.onprem-card__features li { font-size: 0.9375rem; padding-left: 22px; position: relative; }
.onprem-card__features li::before { content: '✓'; position: absolute; left: 0; color: var(--secondary); font-weight: 700; }

@media (max-width: 700px) {
  .onprem-grid { grid-template-columns: 1fr; }
}

.faq { max-width: 720px; margin: 0 auto; }
.faq__title { font-size: 1.75rem; font-weight: 700; margin-bottom: 32px; text-align: center; }
.faq__item { border-bottom: 1px solid var(--border); }
.faq__q {
  display: flex; justify-content: space-between; align-items: center;
  padding: 20px 0; font-weight: 600; cursor: pointer;
  font-size: 1rem; color: var(--dark);
}
.faq__q:hover { color: var(--primary); }
.faq__arrow { color: var(--primary); font-size: 1rem; }
.faq__a { padding: 0 0 20px; color: var(--gray); font-size: 0.9375rem; line-height: 1.65; }

@media (max-width: 1100px) {
  .pricing-grid { grid-template-columns: repeat(2, 1fr); }
  .plan--featured { transform: none; }
}
@media (max-width: 700px) {
  .pricing-grid { grid-template-columns: 1fr; }
  .page-hero__title { font-size: 1.875rem; }
}
</style>
